import {HIDE_SPINNER, SHOW_SPINNER} from '../constants/actionTypes';

export function showSpinner  (){
  return {type:SHOW_SPINNER};
}
export function hideSpinner  (){
  return {type:HIDE_SPINNER};
}
